import React from 'react';
import { ActivityIndicator, StyleSheet } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import { Text } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import constants from '../Config/constants';
import { pluralize } from '../Helper';
import { getCurrency } from '../Helper/Routines';
import storeAPI from '../Service/api/store';
import themeColor from '../Theme/colors';
import ThemeStyle from '../Theme/styles';

type Props = {
  storeId: string;
  trailing?: string;
  type: 1 | 2;
  [key: string]: any;
};

const RatingText: React.FC<Props> = ({
  storeId,
  trailing,
  type = 1,
  ...rest
}) => {
  const { data: result, isFetching: isLoading } = useQuery({
    queryKey: [storeId, 'total-order-rating'],
    queryFn: () => storeAPI.getTotalRatings(storeId),
    enabled: Boolean(storeId),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  const data = isLoading ? {} : result?.data;
  const hide = !storeId || (!isLoading && lodashIsEmpty(data));

  if (hide) {
    return null;
  }

  if (isLoading) {
    return (
      <ActivityIndicator
        size={constants.isIOS ? 16 : 18}
        style={[
          ThemeStyle.alignSelfStart,
          ThemeStyle.spacingRightMedium,
          rest.style,
        ]}
      />
    );
  }

  if (type === 1) {
    return (
      <Text {...rest}>
        {data.average.toFixed(2)}{' '}
        <Text {...rest} style={styles.star}>
          ★
        </Text>{' '}
        ({getCurrency(data.total, 'PHP', true, 0)}){trailing}
      </Text>
    );
  }

  return (
    <Text {...rest}>
      {data.average.toFixed(2)}{' '}
      <Text {...rest} style={styles.star}>
        ★
      </Text>{' '}
      {getCurrency(data.total, 'PHP', true, 0)}{' '}
      {pluralize(data.total, 'review')}
      {trailing}
    </Text>
  );
};

const styles = StyleSheet.create({
  star: {
    color: themeColor.gold,
  },
});

export default RatingText;
